const domainGroupReducer = ( state = {
	findDomainGroup: null,
	loadNewDomainGroup: null,
	isNewCollaboratorsListLoading: false,
	domainGroupNextPage: 2,
	domainGroupPageSize: 15
}, action ) => {
	switch (action.type){
		case "FIND_DOMAIN_GROUP":
			state = {
				...state,
				findDomainGroup: action.payload
			};
			break;
		case "LOAD_NEW_DOMAIN_GROUP":
			state = {
				...state,
				findDomainGroup: {
					...state.findDomainGroup,
					domainGroups: [...state.findDomainGroup.domainGroups, ...action.payload]
				}
			};
			break;
        case "IS_NEW_COLLABORATORS_LIST_LOADING" :
            state = {
                ...state,
                isNewCollaboratorsListLoading: action.payload
            };
            break;
		case "DOMAIN_GROUP_NEXT_PAGE":
			state = {
				...state,
				domainGroupNextPage: action.payload
			};
			break;
		case "DOMAIN_GROUP_PAGE_SIZE":
			state = {
				...state,
				domainGroupPageSize: action.payload
			};
			break;
		default :
			break;
	}
	return state;
};

export default domainGroupReducer;